function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mathRound = Math.round;
var mathMin = Math.min;
var mathMax = Math.max;

var isOnePointZero = function isOnePointZero(n) {
  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
};

var isPercentage = function isPercentage(n) {
  return typeof n === 'string' && n.indexOf('%') !== -1;
};

var roundIf01 = function roundIf01(n) {
  return n < 1 ? mathRound(n) : n;
};

var roundAlpha = function roundAlpha(a) {
  return mathRound(100 * a) / 100;
};

var boundAlpha = function boundAlpha(a) {
  a = parseFloat(a);
  return isNaN(a) || a < 0 || a > 1 ? 1 : a;
};

var hasAlpha = function hasAlpha(rgba) {
  return rgba.a < 1 && rgba.a >= 0;
};

var clamp01 = function clamp01(val) {
  return mathMin(1, mathMax(0, val));
};

var pad2 = function pad2(c) {
  return c.length === 1 ? "0".concat(c) : "".concat(c);
};

var CSS_INTEGER = '[-\\+]?\\d+%?';
var CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
var CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")");

var isValidCSSUnit = function isValidCSSUnit(color) {
  return new RegExp(CSS_UNIT).test(color);
};

var isValidCSSUnitRGB = function isValidCSSUnitRGB(rgb) {
  return isValidCSSUnit(rgb.r) && isValidCSSUnit(rgb.g) && isValidCSSUnit(rgb.b);
};

var PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");

function bound01(n, max) {
  if (isOnePointZero(n)) {
    n = '100%';
  }

  var processPercent = isPercentage(n);
  n = mathMin(max, mathMax(0, parseFloat(n)));

  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  }

  if (Math.abs(n - max) < 0.000001) {
    return 1;
  }

  return n % max / parseFloat(max);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var convertHexToInt = function convertHexToInt(val) {
  return parseInt(val, 16);
};

var convertHexToDecimal = function convertHexToDecimal(h) {
  return convertHexToInt(h) / 255;
};

var convertToPercentage = function convertToPercentage(n) {
  return n <= 1 ? "".concat(n * 100, "%") : n;
};

var rawToRgba = function rawToRgba(raw) {
  var _map = [raw._r, raw._g, raw._b].map(mathRound),
      _map2 = _slicedToArray(_map, 3),
      r = _map2[0],
      g = _map2[1],
      b = _map2[2];

  return {
    r: r,
    g: g,
    b: b,
    a: raw._roundA
  };
};

var rawToDeepRgba = function rawToDeepRgba(raw) {
  return {
    r: raw._r,
    g: raw._g,
    b: raw._b,
    a: raw._a
  };
};

var conformRgba = function conformRgba(rgba) {
  var _map3 = [rgba.r, rgba.g, rgba.b].map(function (n) {
    return bound01(n, 255) * 255;
  }),
      _map4 = _slicedToArray(_map3, 3),
      r = _map4[0],
      g = _map4[1],
      b = _map4[2];

  return {
    r: r,
    g: g,
    b: b,
    a: boundAlpha(rgba.a)
  };
};

var rgbaToPercentageRgba = function rgbaToPercentageRgba(rgba) {
  var _map5 = [rgba.r, rgba.g, rgba.b].map(function (n) {
    return "".concat(mathRound(bound01(n, 255) * 100), "%");
  }),
      _map6 = _slicedToArray(_map5, 3),
      r = _map6[0],
      g = _map6[1],
      b = _map6[2];

  return {
    r: r,
    g: g,
    b: b,
    a: rgba.a
  };
};

var rgbaToString = function rgbaToString(rgba) {
  return rgba.a === 1 ? "rgb(".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ")") : "rgba(".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ", ").concat(rgba.a, ")");
};

var rgbaToArray = function rgbaToArray(rgba) {
  return rgba.a === 1 ? [rgba.r, rgba.g, rgba.b] : [rgba.r, rgba.g, rgba.b, mathRound(rgba.a * 255)];
};

var rgbaToHex = function rgbaToHex(rgba, allowShort) {
  var hex = rgbaToArray(rgba).map(function (n) {
    return n.toString(16);
  }).map(pad2);
  return allowShort && hex.every(function (h) {
    return h.charAt(0) === h.charAt(1);
  }) ? hex.map(function (h) {
    return h.charAt(0);
  }).join('') : hex.join('');
};

var rgbToHex = function rgbToHex(rgba, allowShort) {
  return rgbaToHex(_objectSpread2({}, rgba, {
    a: 1
  }), allowShort);
};

var calcBrightness = function calcBrightness(rgb) {
  return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
};

function calcLuminance(rgb, deepRgb) {
  var R;
  var G;
  var B;
  var RsRGB = deepRgb.r / 255;
  var GsRGB = deepRgb.g / 255;
  var BsRGB = deepRgb.b / 255;

  if (RsRGB <= 0.03928) {
    R = RsRGB / 12.92;
  } else {
    R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
  }

  if (GsRGB <= 0.03928) {
    G = GsRGB / 12.92;
  } else {
    G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
  }

  if (BsRGB <= 0.03928) {
    B = BsRGB / 12.92;
  } else {
    B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
  }

  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

function calcMix(color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = new TinyColor(color1).toRgb();
  var rgb2 = new TinyColor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return new TinyColor(rgba);
}

function validateWCAG2Parms(parms) {
  var level;
  var size;
  parms = parms || {
    level: 'AA',
    size: 'small'
  };
  level = (parms.level || 'AA').toUpperCase();
  size = (parms.size || 'small').toLowerCase();

  if (level !== 'AA' && level !== 'AAA') {
    level = 'AA';
  }

  if (size !== 'small' && size !== 'large') {
    size = 'small';
  }

  return {
    level: level,
    size: size
  };
}

function _readability(color1, color2) {
  var c1 = new TinyColor(color1);
  var c2 = new TinyColor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
}

function _isReadable(color1, color2, wcag2) {
  var readable = _readability(color1, color2);

  var wcag2Parms = validateWCAG2Parms(wcag2);
  var out = false;

  switch (wcag2Parms.level + wcag2Parms.size) {
    case 'AAlarge':
      out = readable >= 3;
      break;

    case 'AAAsmall':
      out = readable >= 7;
      break;

    default:
      out = readable >= 4.5;
  }

  return out;
}

function _mostReadable(baseColor, colorList) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var includeFallbackColors = args.includeFallbackColors,
      level = args.level,
      size = args.size;
  var readable;
  var bestColor = null;
  var bestScore = 0;
  colorList.forEach(function (color) {
    readable = _readability(baseColor, color);

    if (readable > bestScore) {
      bestScore = readable;
      bestColor = new TinyColor(color);
    }
  });

  if (_isReadable(baseColor, bestColor, {
    level: level,
    size: size
  }) || !includeFallbackColors) {
    return bestColor;
  }

  args.includeFallbackColors = false;
  return _mostReadable(baseColor, ['#fff', '#000'], args);
}

function combine(action, args) {
  var actions = {
    monochromatic: monochromatic,
    analogous: analogous,
    complement: complement,
    splitcomplement: splitcomplement,
    triad: triad,
    tetrad: tetrad
  };
  return actions[action].apply(actions, _toConsumableArray(args));
}

function complement(color) {
  var hsl = new TinyColor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return new TinyColor(hsl);
}

function triad(color) {
  var hsl = new TinyColor(color).toHsl();
  var h = hsl.h;
  return [new TinyColor(color), new TinyColor({
    h: (h + 120) % 360,
    s: hsl.s,
    l: hsl.l
  }), new TinyColor({
    h: (h + 240) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}

function tetrad(color) {
  var hsl = new TinyColor(color).toHsl();
  var h = hsl.h;
  return [new TinyColor(color), new TinyColor({
    h: (h + 90) % 360,
    s: hsl.s,
    l: hsl.l
  }), new TinyColor({
    h: (h + 180) % 360,
    s: hsl.s,
    l: hsl.l
  }), new TinyColor({
    h: (h + 270) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}

function splitcomplement(color) {
  var hsl = new TinyColor(color).toHsl();
  var h = hsl.h;
  return [new TinyColor(color), new TinyColor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), new TinyColor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}

function analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = new TinyColor(color).toHsl();
  var part = 360 / slices;
  var ret = [new TinyColor(color)];

  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(new TinyColor(hsl));
  }

  return ret;
}

function monochromatic(color, results) {
  results = results || 6;
  var hsv = new TinyColor(color).toHsv();
  var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
  var ret = [];
  var modification = 1 / results;

  while (results--) {
    ret.push(new TinyColor({
      h: h,
      s: s,
      v: v
    }));
    v = (v + modification) % 1;
  }

  return ret;
}

function modify(action, args) {
  var actions = {
    desaturate: desaturate,
    saturate: saturate,
    greyscale: greyscale,
    lighten: lighten,
    brighten: brighten,
    darken: darken,
    spin: spin
  };
  var color = actions[action].apply(actions, _toConsumableArray(args));

  var _args = _slicedToArray(args, 1),
      source = _args[0];

  source._r = color._r;
  source._g = color._g;
  source._b = color._b;
  source.setAlpha(color._a);
  return source;
}

function desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = new TinyColor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return new TinyColor(hsl);
}

function saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = new TinyColor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return new TinyColor(hsl);
}

function greyscale(color) {
  return new TinyColor(color).desaturate(100);
}

function lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = new TinyColor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return new TinyColor(hsl);
}

function brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = new TinyColor(color).toRgb();
  rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
  rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
  rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
  return new TinyColor(rgb);
}

function darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = new TinyColor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return new TinyColor(hsl);
}

function spin(color, amount) {
  var hsl = new TinyColor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return new TinyColor(hsl);
}

var TinyColorExtension = /*#__PURE__*/function () {
  function TinyColorExtension(api, id) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, TinyColorExtension);

    this.api = api;
    this.id = id;
    this.opts = opts;
  }

  _createClass(TinyColorExtension, [{
    key: "use",
    value: function use(specified) {
      this.wanted = specified;
      return this;
    }
  }, {
    key: "parse",
    value: function parse(input) {
      var result = this.api.find(input);
      return {
        as: function as(format) {
          return Object.assign(result, {
            format: format
          });
        },
        rgba: {
          r: result.r,
          g: result.g,
          b: result.b,
          a: result.a
        },
        valueOf: function valueOf() {
          return result;
        }
      };
    }
  }, {
    key: "print",
    value: function print(id, rgba) {
      return this.api.print(rgba, id);
    }
  }, {
    key: "complete",
    value: function complete(rgba) {
      var output = this.toString(rgba);
      delete this.wanted;
      return output;
    }
  }]);

  return TinyColorExtension;
}();

var _template = {
  format: false,
  ok: false,
  r: 0,
  g: 0,
  b: 0,
  a: 1
};

var TinyColorExtensionAPI = /*#__PURE__*/function () {
  function TinyColorExtensionAPI() {
    _classCallCheck(this, TinyColorExtensionAPI);

    this.colorspaces = {};
    this.opts = {
      alphaFormat: 'rgb',
      shortHex: false,
      upperCaseHex: false
    };
  }

  _createClass(TinyColorExtensionAPI, [{
    key: "set",
    value: function set(opts) {
      Object.assign(this.opts, opts);

      for (var id in this.colorspaces) {
        if ({}.hasOwnProperty.call(this.colorspaces, id)) {
          Object.assign(this.colorspaces[id].opts, opts);
        }
      }
    }
  }, {
    key: "add",
    value: function add(id, opts) {
      var _this = this;

      this.colorspaces[id] = new TinyColorExtension(this, id, _objectSpread2({}, this.opts, {}, opts));

      if (opts.alias) {
        opts.alias.forEach(function (id_) {
          _this.colorspaces[id_] = _this.colorspaces[id];
        });
      }

      return this.colorspaces[id];
    }
  }, {
    key: "find",
    value: function find(input) {
      var color = _objectSpread2({}, _template);

      input = typeof input === 'string' ? input.trim().toLowerCase() : input;

      if (input) {
        for (var id in this.colorspaces) {
          if (this.colorspaces[id].shouldHandleInput(input)) {
            Object.assign(color, this.colorspaces[id].toRgb(input));
            color.format = color.format || id;
            color.ok = true;
            break;
          }
        }
      }

      return color;
    }
  }, {
    key: "raw",
    value: function raw(rgba, format) {
      if (format in this.colorspaces) {
        return this.colorspaces[format].toRaw(rgba);
      }

      return {
        r: rgba.r / 255,
        g: rgba.g / 255,
        b: rgba.b / 255,
        a: rgba.a
      };
    }
  }, {
    key: "print",
    value: function print(rgba, original, format) {
      var specified = format;
      format = format || original;

      if (format in this.colorspaces) {
        return this.colorspaces[format].use(specified).complete(rgba);
      }

      return "[".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ", ").concat(rgba.a * 255, "]");
    }
  }]);

  return TinyColorExtensionAPI;
}();

var tinyCounter = 0;
var extensionApi = new TinyColorExtensionAPI();

var TinyColor = /*#__PURE__*/function () {
  function TinyColor(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, TinyColor);

    color = color || '';

    if (color instanceof TinyColor) {
      return color;
    }

    var rgba = extensionApi.find(color);
    this._originalInput = color;
    this._r = roundIf01(rgba.r);
    this._g = roundIf01(rgba.g);
    this._b = roundIf01(rgba.b);
    this._a = rgba.a;
    this._roundA = roundAlpha(this._a);
    this._format = opts.format || rgba.format;
    this._gradientType = opts.gradientType;
    this._ok = rgba.ok;
    this._tc_id = TinyColor.newId();
    extensionApi.set(opts);
  }

  _createClass(TinyColor, [{
    key: "isDark",
    value: function isDark() {
      return this.getBrightness() < 128;
    }
  }, {
    key: "isLight",
    value: function isLight() {
      return !this.isDark();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this._ok;
    }
  }, {
    key: "getOriginalInput",
    value: function getOriginalInput() {
      return this._originalInput;
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      return this._format;
    }
  }, {
    key: "getAlpha",
    value: function getAlpha() {
      return this._a;
    }
  }, {
    key: "getBrightness",
    value: function getBrightness() {
      return calcBrightness(this.toRgb());
    }
  }, {
    key: "getLuminance",
    value: function getLuminance() {
      return calcLuminance(this.toRgb(), rawToDeepRgba(this));
    }
  }, {
    key: "toString",
    value: function toString(format) {
      return extensionApi.print(rawToRgba(this), this._format, format);
    }
  }, {
    key: "toName",
    value: function toName() {
      return extensionApi.print(rawToRgba(this), 'name', 'toName');
    }
  }, {
    key: "toRgb",
    value: function toRgb() {
      return rawToDeepRgba(this);
    }
  }, {
    key: "toRgbString",
    value: function toRgbString() {
      return rgbaToString(rawToRgba(this));
    }
  }, {
    key: "toRgbArray",
    value: function toRgbArray() {
      return rgbaToArray(rawToRgba(this));
    }
  }, {
    key: "toPercentageRgb",
    value: function toPercentageRgb() {
      return rgbaToPercentageRgba(rawToDeepRgba(this));
    }
  }, {
    key: "toPercentageRgbString",
    value: function toPercentageRgbString() {
      return rgbaToString(rgbaToPercentageRgba(rawToRgba(this)));
    }
  }, {
    key: "toHex",
    value: function toHex(allow3Char) {
      return rgbToHex(rawToRgba(this), allow3Char);
    }
  }, {
    key: "toHexString",
    value: function toHexString(allow3Char) {
      return "#".concat(this.toHex(allow3Char));
    }
  }, {
    key: "toHex8",
    value: function toHex8(allow4Char) {
      return rgbaToHex(rawToRgba(this), allow4Char);
    }
  }, {
    key: "toHex8String",
    value: function toHex8String(allow4Char) {
      return "#".concat(this.toHex8(allow4Char));
    }
  }, {
    key: "toHsv",
    value: function toHsv() {
      return extensionApi.raw(rawToDeepRgba(this), 'hsv');
    }
  }, {
    key: "toHsvString",
    value: function toHsvString() {
      return extensionApi.print(rawToDeepRgba(this), this._format, 'hsv');
    }
  }, {
    key: "toHsl",
    value: function toHsl() {
      return extensionApi.raw(rawToDeepRgba(this), 'hsl');
    }
  }, {
    key: "toHslString",
    value: function toHslString() {
      return extensionApi.print(rawToDeepRgba(this), this._format, 'hsl');
    }
  }, {
    key: "setAlpha",
    value: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = mathRound(100 * this._a) / 100;
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new TinyColor(this.toString());
    }
  }, {
    key: "lighten",
    value: function lighten() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return modify('lighten', [this].concat(args));
    }
  }, {
    key: "brighten",
    value: function brighten() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return modify('brighten', [this].concat(args));
    }
  }, {
    key: "darken",
    value: function darken() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return modify('darken', [this].concat(args));
    }
  }, {
    key: "desaturate",
    value: function desaturate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return modify('desaturate', [this].concat(args));
    }
  }, {
    key: "saturate",
    value: function saturate() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return modify('saturate', [this].concat(args));
    }
  }, {
    key: "greyscale",
    value: function greyscale() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return modify('greyscale', [this].concat(args));
    }
  }, {
    key: "spin",
    value: function spin() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return modify('spin', [this].concat(args));
    }
  }, {
    key: "analogous",
    value: function analogous() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      return combine('analogous', [this].concat(args));
    }
  }, {
    key: "complement",
    value: function complement() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      return combine('complement', [this].concat(args));
    }
  }, {
    key: "monochromatic",
    value: function monochromatic() {
      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      return combine('monochromatic', [this].concat(args));
    }
  }, {
    key: "splitcomplement",
    value: function splitcomplement() {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }

      return combine('splitcomplement', [this].concat(args));
    }
  }, {
    key: "triad",
    value: function triad() {
      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }

      return combine('triad', [this].concat(args));
    }
  }, {
    key: "tetrad",
    value: function tetrad() {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }

      return combine('tetrad', [this].concat(args));
    }
  }], [{
    key: "newId",
    value: function newId() {
      return tinyCounter++;
    }
  }, {
    key: "registerFormat",
    value: function registerFormat(id) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return extensionApi.add(id, opts);
    }
  }, {
    key: "equals",
    value: function equals(color1, color2) {
      if (!color1 || !color2) {
        return false;
      }

      return new TinyColor(color1).toRgbString() === new TinyColor(color2).toRgbString();
    }
  }, {
    key: "fromRatio",
    value: function fromRatio(color, opts) {
      if (_typeof(color) === 'object') {
        var newColor = {};

        for (var i in color) {
          if ({}.hasOwnProperty.call(color, i)) {
            if (i === 'a') {
              newColor[i] = color[i];
            } else {
              newColor[i] = convertToPercentage(color[i]);
            }
          }
        }

        color = newColor;
      }

      return new TinyColor(color, opts);
    }
  }, {
    key: "readability",
    value: function readability(color1, color2) {
      return _readability(color1, color2);
    }
  }, {
    key: "isReadable",
    value: function isReadable(color1, color2, wcag2) {
      return _isReadable(color1, color2, wcag2);
    }
  }, {
    key: "mostReadable",
    value: function mostReadable(baseColor, colorList, args) {
      return _mostReadable(baseColor, colorList, args);
    }
  }, {
    key: "mix",
    value: function mix(color1, color2, amount) {
      return calcMix(color1, color2, amount);
    }
  }]);

  return TinyColor;
}();

var matchers = function () {
  return {
    rgb: new RegExp("rgb".concat(PERMISSIVE_MATCH3)),
    rgba: new RegExp("rgba".concat(PERMISSIVE_MATCH4))
  };
}();

function rgbStringToObject(color) {
  var r, g, b, a, match;

  if (match = matchers.rgb.exec(color)) {
    var _match$splice = match.splice(1, 3);

    var _match$splice2 = _slicedToArray(_match$splice, 3);

    r = _match$splice2[0];
    g = _match$splice2[1];
    b = _match$splice2[2];
    return {
      r: r,
      g: g,
      b: b
    };
  }

  if (match = matchers.rgba.exec(color)) {
    var _match$splice3 = match.splice(1, 4);

    var _match$splice4 = _slicedToArray(_match$splice3, 4);

    r = _match$splice4[0];
    g = _match$splice4[1];
    b = _match$splice4[2];
    a = _match$splice4[3];
    return {
      r: r,
      g: g,
      b: b,
      a: a
    };
  }

  return false;
}

var api = TinyColor.registerFormat('rgb');

api.shouldHandleInput = function (input) {
  return _typeof(input) === 'object' && isValidCSSUnitRGB(input) && !isPercentage(input.r) || rgbStringToObject(input);
};

api.toRgb = function (input) {
  return _typeof(input) === 'object' && conformRgba(input) || conformRgba(rgbStringToObject(input));
};

api.toRaw = function (rgba) {
  return rgba;
};

api.toString = function (rgba) {
  return rgbaToString(rgba);
};

var api$1 = TinyColor.registerFormat('prgb');

api$1.shouldHandleInput = function (input) {
  if (typeof input === 'string') {
    var rgbCheck = rgbStringToObject(input);
    return rgbCheck && isPercentage(rgbCheck.r);
  }

  return isValidCSSUnitRGB(input) && isPercentage(input.r);
};

api$1.toRgb = function (input) {
  return _typeof(input) === 'object' ? conformRgba(input) : conformRgba(rgbStringToObject(input));
};

api$1.toRaw = function (rgba) {
  return rgbaToPercentageRgba(rgba);
};

api$1.toString = function (rgba) {
  return rgbaToString(rgbaToPercentageRgba(rgba));
};

var api$2 = TinyColor.registerFormat('hex', {
  alias: ['hex3', 'hex6']
});

var matchers$1 = function () {
  return {
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();

function hexToRgba(color) {
  var match;

  if (match = matchers$1.hex3.exec(color)) {
    var _match$splice$map$map = match.splice(1, 3).map(function (h) {
      return "".concat(h).concat(h);
    }).map(convertHexToInt),
        _match$splice$map$map2 = _slicedToArray(_match$splice$map$map, 3),
        r = _match$splice$map$map2[0],
        g = _match$splice$map$map2[1],
        b = _match$splice$map$map2[2];

    return {
      r: r,
      g: g,
      b: b,
      a: 1
    };
  }

  if (match = matchers$1.hex6.exec(color)) {
    var _match$splice$map = match.splice(1, 3).map(convertHexToInt),
        _match$splice$map2 = _slicedToArray(_match$splice$map, 3),
        _r = _match$splice$map2[0],
        _g = _match$splice$map2[1],
        _b = _match$splice$map2[2];

    return {
      r: _r,
      g: _g,
      b: _b,
      a: 1
    };
  }

  return false;
}

var hexToString = function hexToString(rgba) {
  var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : api$2.opts.shortHex;
  return "#".concat(api$2.opts.upperCaseHex ? rgbToHex(rgba, short).toUpperCase() : rgbToHex(rgba, short));
};

api$2.shouldHandleInput = function (input) {
  return matchers$1.hex6.test(input) || matchers$1.hex3.test(input);
};

api$2.toRgb = function (input) {
  return hexToRgba(input);
};

api$2.toRaw = function (rgba) {
  return rgba;
};

api$2.toString = function (rgba) {
  if (/^hex6?$/.test(api$2.wanted)) {
    return hexToString(rgba);
  }

  if (api$2.wanted === 'hex3') {
    return hexToString(rgba, true);
  }

  if (hasAlpha(rgba)) {
    return api$2.opts.alphaFormat === 'hex' ? hexToString(rgba) : api$2.print(api$2.opts.alphaFormat, rgba);
  }

  return hexToString(rgba);
};

var api$3 = TinyColor.registerFormat('hex8', {
  alias: ['hex4']
});

var matchers$2 = function () {
  return {
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();

function hexToRgba$1(color) {
  var match;

  if (match = matchers$2.hex4.exec(color)) {
    var a = convertHexToDecimal("".concat(match[4]).concat(match[4]));

    var _match$splice$map$map3 = match.splice(1, 3).map(function (h) {
      return "".concat(h).concat(h);
    }).map(convertHexToInt),
        _match$splice$map$map4 = _slicedToArray(_match$splice$map$map3, 3),
        r = _match$splice$map$map4[0],
        g = _match$splice$map$map4[1],
        b = _match$splice$map$map4[2];

    return {
      r: r,
      g: g,
      b: b,
      a: a
    };
  }

  if (match = matchers$2.hex8.exec(color)) {
    var _a = convertHexToDecimal(match[4]);

    var _match$splice$map3 = match.splice(1, 3).map(convertHexToInt),
        _match$splice$map4 = _slicedToArray(_match$splice$map3, 3),
        _r2 = _match$splice$map4[0],
        _g2 = _match$splice$map4[1],
        _b2 = _match$splice$map4[2];

    return {
      r: _r2,
      g: _g2,
      b: _b2,
      a: _a
    };
  }

  return false;
}

var hexToString$1 = function hexToString$1(rgba) {
  var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : api$3.opts.shortHex;
  return "#".concat(api$3.opts.upperCaseHex ? rgbaToHex(rgba, short).toUpperCase() : rgbaToHex(rgba, short));
};

api$3.shouldHandleInput = function (input) {
  return matchers$2.hex8.test(input) || matchers$2.hex4.test(input);
};

api$3.toRgb = function (input) {
  return hexToRgba$1(input);
};

api$3.toRaw = function (rgba) {
  return rgba;
};

api$3.toString = function (rgba) {
  if (api$3.wanted === 'hex4') {
    return hexToString$1(rgba, true);
  }

  if (api$3.wanted === 'hex8') {
    return hexToString$1(rgba);
  }

  if (hasAlpha(rgba)) {
    return api$3.opts.alphaFormat === 'hex' ? hexToString$1(rgba) : api$3.print(api$3.opts.alphaFormat, rgba);
  }

  return hexToString$1(rgba);
};

var api$4 = TinyColor.registerFormat('hsl');

var matchers$3 = function () {
  return {
    hsl: new RegExp("hsl".concat(PERMISSIVE_MATCH3)),
    hsla: new RegExp("hsla".concat(PERMISSIVE_MATCH4))
  };
}();

var isValidCSSUnitHSL = function isValidCSSUnitHSL(hsl) {
  return isValidCSSUnit(hsl.h) && isValidCSSUnit(hsl.s) && isValidCSSUnit(hsl.l);
};

function rgbaToHsla(rgba) {
  var r = bound01(rgba.r, 255);
  var g = bound01(rgba.g, 255);
  var b = bound01(rgba.b, 255);
  var a = rgba.a || 1;
  var max = mathMax(r, g, b);
  var min = mathMin(r, g, b);
  var h, s;
  var l = (max + min) / 2;

  if (max === min) {
    h = 0;
    s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      default:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    l: l,
    a: a
  };
}

function hslaToRgba(hsla) {
  var h = bound01(hsla.h, 360);
  var s = bound01(convertToPercentage(hsla.s), 100);
  var l = bound01(convertToPercentage(hsla.l), 100);
  var a = hsla.a || 1;
  var r, g, b;

  function hue2rgb(p, q, t) {
    t = t < 0 ? t + 1 : t;
    t = t > 1 ? t - 1 : t;

    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }

    if (t < 1 / 2) {
      return q;
    }

    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }

    return p;
  }

  if (s === 0) {
    r = l;
    g = l;
    b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return {
    r: r * 255,
    g: g * 255,
    b: b * 255,
    a: a
  };
}

function hslStringToObject(color) {
  var h, s, l, a, match;

  if (match = matchers$3.hsl.exec(color)) {
    var _match$splice5 = match.splice(1, 3);

    var _match$splice6 = _slicedToArray(_match$splice5, 3);

    h = _match$splice6[0];
    s = _match$splice6[1];
    l = _match$splice6[2];
    return {
      h: h,
      s: s,
      l: l
    };
  }

  if (match = matchers$3.hsla.exec(color)) {
    var _match$splice7 = match.splice(1, 4);

    var _match$splice8 = _slicedToArray(_match$splice7, 4);

    h = _match$splice8[0];
    s = _match$splice8[1];
    l = _match$splice8[2];
    a = _match$splice8[3];
    return {
      h: h,
      s: s,
      l: l,
      a: a
    };
  }

  return false;
}

function hslaToString(hsla) {
  var h = hsla.h,
      s = hsla.s,
      l = hsla.l,
      a = hsla.a;
  h = mathRound(h * 360);
  s = mathRound(s * 100);
  l = mathRound(l * 100);
  return a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(a, ")");
}

function hslaToRaw(hsla) {
  var h = hsla.h,
      s = hsla.s,
      l = hsla.l,
      a = hsla.a;
  h *= 360;
  return {
    h: h,
    s: s,
    l: l,
    a: a
  };
}

api$4.shouldHandleInput = function (input) {
  return _typeof(input) === 'object' && isValidCSSUnitHSL(input) || hslStringToObject(input);
};

api$4.toRgb = function (input) {
  return _typeof(input) === 'object' && hslaToRgba(input) || hslaToRgba(hslStringToObject(input));
};

api$4.toRaw = function (rgba) {
  return hslaToRaw(rgbaToHsla(rgba));
};

api$4.toString = function (rgba) {
  return hslaToString(rgbaToHsla(rgba));
};

var api$5 = TinyColor.registerFormat('hsv');

var matchers$4 = function () {
  return {
    hsv: new RegExp("hsv".concat(PERMISSIVE_MATCH3)),
    hsva: new RegExp("hsva".concat(PERMISSIVE_MATCH4))
  };
}();

var isValidCSSUnitHSV = function isValidCSSUnitHSV(hsv) {
  return isValidCSSUnit(hsv.h) && isValidCSSUnit(hsv.s) && isValidCSSUnit(hsv.v);
};

function rgbaToHsva(rgba) {
  var r = bound01(rgba.r, 255);
  var g = bound01(rgba.g, 255);
  var b = bound01(rgba.b, 255);
  var a = rgba.a || 1;
  var max = mathMax(r, g, b);
  var min = mathMin(r, g, b);
  var d = max - min;
  var h;
  var s = max === 0 ? 0 : d / max;
  var v = max;

  if (max === min) {
    h = 0;
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      default:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    v: v,
    a: a
  };
}

function hsvaToRgba(hsva) {
  var h = bound01(hsva.h, 360) * 6;
  var s = bound01(convertToPercentage(hsva.s), 100);
  var v = bound01(convertToPercentage(hsva.v), 100);
  var a = hsva.a || 1;
  var i = Math.floor(h);
  var f = h - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  var mod = i % 6;
  var r = [v, q, p, p, t, v][mod];
  var g = [t, v, v, q, p, p][mod];
  var b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255,
    a: a
  };
}

function hsvStringToObject(color) {
  var h, s, v, a, match;

  if (match = matchers$4.hsv.exec(color)) {
    var _match$splice9 = match.splice(1, 3);

    var _match$splice10 = _slicedToArray(_match$splice9, 3);

    h = _match$splice10[0];
    s = _match$splice10[1];
    v = _match$splice10[2];
    return {
      h: h,
      s: s,
      v: v
    };
  }

  if (match = matchers$4.hsva.exec(color)) {
    var _match$splice11 = match.splice(1, 4);

    var _match$splice12 = _slicedToArray(_match$splice11, 4);

    h = _match$splice12[0];
    s = _match$splice12[1];
    v = _match$splice12[2];
    a = _match$splice12[3];
    return {
      h: h,
      s: s,
      v: v,
      a: a
    };
  }

  return false;
}

function hsvaToString(hsva) {
  var h = hsva.h,
      s = hsva.s,
      v = hsva.v,
      a = hsva.a;
  h = mathRound(h * 360);
  s = mathRound(s * 100);
  v = mathRound(v * 100);
  return a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(a, ")");
}

function hsvaToRaw(hsla) {
  var h = hsla.h,
      s = hsla.s,
      v = hsla.v,
      a = hsla.a;
  h *= 360;
  return {
    h: h,
    s: s,
    v: v,
    a: a
  };
}

api$5.shouldHandleInput = function (input) {
  return _typeof(input) === 'object' && isValidCSSUnitHSV(input) || hsvStringToObject(input);
};

api$5.toRgb = function (input) {
  return _typeof(input) === 'object' && hsvaToRgba(input) || hsvaToRgba(hsvStringToObject(input));
};

api$5.toRaw = function (rgba) {
  return hsvaToRaw(rgbaToHsva(rgba));
};

api$5.toString = function (rgba) {
  return hsvaToString(rgbaToHsva(rgba));
};

var api$6 = TinyColor.registerFormat('name', {
  alias: ['toName']
});

function flip(o) {
  var flipped = {};

  for (var i in o) {
    if ({}.hasOwnProperty.call(o, i)) {
      flipped[o[i]] = i;
    }
  }

  return flipped;
}

var names = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '0ff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '00f',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  burntsienna: 'ea7e5d',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '0ff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'f0f',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
names.transparent = '00000000';
var hexNames = flip(names);

api$6.shouldHandleInput = function (input) {
  return names[input];
};

api$6.toRgb = function (input) {
  return api$6.parse(names[input]).rgba;
};

api$6.toRaw = function (rgba) {
  return rgba;
};

api$6.toString = function (rgba) {
  if (rgba.a === 0) {
    return 'transparent';
  }

  if (hasAlpha(rgba) && api$6.wanted === 'toName') {
    return false;
  }

  if (hasAlpha(rgba) && api$6.wanted === 'name') {
    return "#".concat(rgbToHex(rgba));
  }

  if (hasAlpha(rgba)) {
    return api$6.print(api$6.opts.alphaFormat, rgba);
  }

  return hexNames[rgbToHex(rgba, true)] || false;
};

function tinycolor(color, opts) {
  return new TinyColor(color, opts);
}

tinycolor.equals = TinyColor.equals;
tinycolor.registerFormat = TinyColor.registerFormat;
tinycolor.fromRatio = TinyColor.fromRatio;
tinycolor.mix = TinyColor.mix;
tinycolor.readability = TinyColor.readability;
tinycolor.isReadable = TinyColor.isReadable;
tinycolor.mostReadable = TinyColor.mostReadable;
tinycolor.names = names;
export { TinyColor, names, tinycolor };